export default ({ request }) => ({
  tskInfoDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/tsk/info/detail',
      method: 'post',
      data,
    })
  },
})
